export function header() {
    let $win = $(window);
    let $body = $("body");
    let windowScroll = 0;
    let showMenuClass = "show-menu";
    let showDropClass = "show-drop";
    let $backButton = $(".header-bottom .back");
    let changeDOMElementPosition = (parentElement, domElement, fromElement, whereElement, breakpoint = 1200) => {
        $(parentElement).each((index, parent) => {
            if (parent) {
                const elem = $(parent).find(domElement);
                const fromElementDOM = $(parent).find(fromElement);
                const whereElementDOM = $(parent).find(whereElement) || parent;

                if ($win.width() < breakpoint && !elem.hasClass("inserted")) {
                    elem.detach();
                    elem.insertBefore(whereElementDOM);
                    elem.addClass("inserted");
                }
                if ($win.width() >= breakpoint && elem.hasClass("inserted")) {
                    elem.detach();
                    fromElementDOM.append(elem);
                    elem.removeClass("inserted");
                }
            }
        });
    };
    let menuItemWithDrop = $(".header-nav-has-child");
    let $cartModal = $("[data-modal='cart']");
    // let last = 0;

    $body.on("click", ".btn-menu", function (e) {
        e.preventDefault();

        if ($win.width() < 1200 && $body.hasClass(showMenuClass)) {
            $backButton.trigger("click");
        }

        $body.toggleClass(showMenuClass);
    });

    menuItemWithDrop.hover(function () {
        const itemParent = $(this).closest("li");

        if ($win.width() >= 1200 && $body.hasClass("no-touch")) {
            $(".header-nav > ul > li").removeClass(showDropClass);
            if (!$body.find(".bg-drop").length) {
                $body.append("<span class='bg-drop'>&nbsp;</span>");
            }
            itemParent.addClass(showDropClass);

            $body.addClass(showDropClass + "-page");

        }
    }, function () {
        const itemParent = $(this).closest("li");
        if ($win.width() >= 1200 && $body.hasClass("no-touch")) {
            itemParent.removeClass(showDropClass);
            $body.removeClass(showDropClass + "-page");
        }
    });

    menuItemWithDrop.find(" > a").on("click", function (e) {

        const itemParent = $(this).closest("li");

        if ($win.width() < 1200 && !itemParent.hasClass("show-drop") || $win.width() > 1200 && $body.hasClass("touch")) {
            e.preventDefault();
        }

        if (itemParent.hasClass("header-nav-has-child") && $win.width() < 1200) {
            $(".header-nav > ul > li")
                .removeClass(showDropClass)
                .addClass("hide");

            itemParent
                .closest("li")
                .removeClass("hide")
                .addClass(showDropClass);

            $backButton.addClass("active");
        }
        if (itemParent.hasClass("header-nav-has-child") && $body.hasClass("touch")) {
            $(".header-nav > ul > li")
                .removeClass(showDropClass);

            itemParent
                .closest("li")
                .addClass(showDropClass);
        }
    });

    $backButton.on("click", function (e) {
        $(this).removeClass("active");
        $(".header-nav > ul > li").removeClass(showDropClass).removeClass("hide");
    });

    $body.on("click", function (e) {
        if (!$(e.target).hasClass("header-nav-link-view")) {
            $(".header-nav").find("li").removeClass(showDropClass);
            $body.removeClass(showDropClass + "-page");
        }
    });

    const $header = $(".header");
    const isDarkHero = $(".hero-section-bg.has-dark-overlay");
    const errorPage = $(".error-page");
    if (!isDarkHero.closest(".hero-slider").length && !errorPage) {
        $header.addClass("white");
    }

    $win.on("load resize", function () {
        changeDOMElementPosition(".header", ".header-logo-row", ".header-top .container", ".header-holder");
        changeDOMElementPosition(".header", ".cart-link", ".cart-link-item", ".header-holder");

        windowScroll = $(window).scrollTop();
        if (windowScroll > 0) {
            $header.addClass("scrolled");
        }
        if (windowScroll <= 0) {
            $header.removeClass("scrolled");
        }
    });

    $win.on("scroll", function (e) {
        windowScroll = $(window).scrollTop();

        if (windowScroll > 0) {
            $header.addClass("has-layer");
        }

        if (windowScroll <= 0) {
            $header.removeClass("has-layer");
        }

        if ($body.hasClass("show-drop-page")) {
            $body.removeClass("show-drop-page");
            $(".header-nav").find("li").removeClass(showDropClass);
        }
    });

    $(window).on("wheel", function (e){

        if ($cartModal && $cartModal.hasClass("show")) {
            return;
        }

        if (e.originalEvent.wheelDelta >= 8 && e.originalEvent.wheelDelta > 0){
            $header.removeClass("scrolled");
        } else if (e.originalEvent.wheelDelta < 0 && e.originalEvent.wheelDelta <= -7) {
            $header.addClass("scrolled");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js